export const SECTIONS = [
  { id: 'basics', title: 'Basics' },
  { id: 'about', title: '1 — About your child' },
  { id: 'adhd', title: '2 — How it shows up (Profile)' },
  { id: 'strategies', title: '3 — What works & what doesn\'t' },
  { id: 'schoolday', title: '4 — The school day' },
  { id: 'team', title: '5 — Your team' },
];

const asArray = (value) => {
  if (Array.isArray(value)) return value;
  if (typeof value === 'string' && value) return [value];
  return [];
};

export const hasCondition = (answers, label) => asArray(answers.condition)
  .some((condition) => condition.includes(label));

export const hasAdditionalProfile = (answers, label) => asArray(answers.additionalProfiles)
  .some((profile) => profile.includes(label));

export const needsSensoryQuestions = (answers) => (
  hasCondition(answers, 'Sensory')
  || hasAdditionalProfile(answers, 'Sensory Processing')
  || hasAdditionalProfile(answers, 'Developmental Coordination')
);
